import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { provideAppShellTooltipConfig } from '@core/product-updates-logic';
import {
  injectTellentIsOneSettingsEnabled,
  TellentAppShellStateService,
  TellentCurrentUserService,
} from '@core/tellent-logic';
import { AppCoreHr, AppRecruitment, BRAND, SeatKind, TellentBrand } from '@core/tellent-types';

@Injectable()
export class TellentAppSwitcherNextController {
  #brand = inject(BRAND);
  #svc = inject(TellentCurrentUserService);
  #me = toSignal(this.#svc.me$);
  #isOneSettingsEnabled = injectTellentIsOneSettingsEnabled({ optional: true }) ?? false;
  #appShellStateSvc = inject(TellentAppShellStateService, { optional: true });

  public featureDiscovery = provideAppShellTooltipConfig();

  public apps = computed(
    (): {
      [SeatKind.Recruitment]: (AppRecruitment & { active: boolean }) | undefined;
      [SeatKind.CoreHR]: (AppCoreHr & { active: boolean }) | undefined;
      admin: { active: boolean } | undefined;
    } => {
      const me = this.#me();
      const isMobile = this.#appShellStateSvc ? this.#appShellStateSvc.isMobile() : false;

      const HRIS = <AppCoreHr | undefined>(
        me?.seats.find(seat => seat.app.kind === SeatKind.CoreHR)?.app
      );

      const ATS = <AppRecruitment | undefined>(
        me?.seats.find(seat => seat.app.kind === SeatKind.Recruitment)?.app
      );

      const canAccessTellentAdmin = me?.abilities?.length! > 0;

      return {
        [SeatKind.CoreHR]: HRIS
          ? {
              ...HRIS,
              active: this.#brand === TellentBrand.Kiwi || this.#brand === TellentBrand.Javelo,
            }
          : undefined,
        [SeatKind.Recruitment]: ATS
          ? { ...ATS, active: this.#brand === TellentBrand.Recruitee }
          : undefined,
        admin: this.#isOneSettingsEnabled
          ? isMobile
            ? undefined
            : { active: this.#brand === TellentBrand.Tellent }
          : canAccessTellentAdmin
            ? { active: this.#brand === TellentBrand.Tellent }
            : undefined,
      };
    },
  );
}
